export default __webpack_public_path__ + "static/media/PalliserOne.edf542d2.jpg";